export default __webpack_public_path__ + "graphics/hyperlink-white-icon.f77dee6e.svg";